import { createRouter , createWebHashHistory } from 'vue-router'
import Welcome from '@/components/WelcomePage.vue'
import Login from '@/components/LoginUser.vue'
import Register from '@/components/RegisterUser.vue'
import Search from '@/components/SearchPage.vue'
import Communities from '@/components/CommunityOverview.vue'
import About from '@/components/AboutPage.vue'

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: Welcome
    },
    {
        path: '/search',
        name: 'search',
        component: Search
    },
    {
        path: '/communities',
        name: 'communities',
        component: Communities
    },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    }]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
